<script setup lang="ts">
import { LocationForm } from '@/components/Forms';
import { PersonStores } from '@/store';
import { LocationFormInterface } from '@/types';
import { useToast } from 'primevue/usetoast';

/**
 * set up the toast
 */
const toast = useToast();

/**
 * All of the state references including the convertion of the
 * profile location state object into a ref.
 */
const profileStore = PersonStores.useUserProfileStore();

/**
 * Handle save event emitted by the child component
 * in order to reset the user location data.
 */
const onSave = async (data: LocationFormInterface) => {
  profileStore.location = data;
  const response = await profileStore.updateLocationInfo(data);
  if (response === 200) {
    doToast();
  } else {
    doToast(true);
  }
};
/**
 * Display the toast message.
 */
const doToast = (error = false) => {
  toast.add({
    severity: error ? 'error' : 'success',
    summary: error ? 'Error' : 'Saved',
    detail: error ? 'there was an error' : 'Location information has been saved',
    life: 3000,
  });
};
</script>

<template>
  <div v-if="profileStore.location && profileStore.isAuth">
    <LocationForm
      :permission-to-edit="true"
      :data="profileStore.location"
      :is-organization="false"
      :loading="profileStore.loading"
      @save="onSave"
    />
  </div>
</template>
